"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyDocketDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_policy_docket_entity_1 = require("./opportunity-policy-docket.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const look_up_entity_1 = require("./look-up.entity");
let PolicyDocketDocumentMap = class PolicyDocketDocumentMap {
};
exports.PolicyDocketDocumentMap = PolicyDocketDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_docket_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentMap.prototype, "policyDocketId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_policy_docket_entity_1.OpportunityPolicyDocket, (policyDocket) => policyDocket.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_docket_id" }),
    tslib_1.__metadata("design:type", Object)
], PolicyDocketDocumentMap.prototype, "policyDocket", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (file) => file.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], PolicyDocketDocumentMap.prototype, "document", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, (lookup) => lookup.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], PolicyDocketDocumentMap.prototype, "documentType", void 0);
exports.PolicyDocketDocumentMap = PolicyDocketDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_docket_document_map")
], PolicyDocketDocumentMap);
